module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.displayInBrowser) ? _c('div', {
    staticClass: "weui-search-bar",
    staticStyle: {
      "padding": "0",
      "background-color": "#ededed"
    },
    attrs: {
      "id": "searchBar"
    }
  }, [_c('form', {
    staticClass: "weui-search-bar__form",
    staticStyle: {
      "padding": "0 10px"
    },
    on: {
      "submit": function () {
        return false;
      }
    }
  }, [_c('div', {
    staticClass: "weui-search-bar__box",
    staticStyle: {
      "background-color": "#F7F8FA"
    }
  }, [_c('i', {
    staticClass: "weui-icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "weui-search-bar__input",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "type": "search",
      "placeholder": "搜索",
      "required": ""
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": _vm.handleChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": _vm.clearKeyword
    }
  }, [_vm._v("取消")])])])]) : _c('div', {
    staticClass: "bar",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "searchbar",
    staticStyle: {
      "background-color": "#F7F8FA",
      "height": "45px"
    }
  }, [_c('a', {
    staticClass: "searchbar-cancel close-popup",
    on: {
      "click": _vm.clearKeyword
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchGoods"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.keyword),
      expression: "keyword",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "placeholder": "搜索"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": _vm.handleChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c199b1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/components/GcSearchInput.vue
// module id = 1531
// module chunks = 8